import { ProjectUserDependenciesReadModel } from "@ProjectUsers/Domain/readmodels";

export class ProjectUserDeleterViewModel
{
    opened: boolean = false;

    projectUserId: number | null = null;
    projectUserName: string | null = null;

    deps: ProjectUserDependenciesReadModel | null = null;


    show(projectUserId: number, projectUserName: string)
    {
        this.deps = null;

        this.projectUserId = projectUserId;
        this.projectUserName = projectUserName;

        this.opened = true;
    }

    setData(deps: ProjectUserDependenciesReadModel)
    {
        this.deps = deps;
    }

    close()
    {
        this.opened = false;

        this.deps = null;
        this.projectUserId = null;
        this.projectUserName = null;
    }
}